import React from "react";
import BusinessSwitcher from "./BusinessSwitcher";

const BusinessHeader = () => {
  return (
    <div className="w-full bg-white shadow-sm py-3 px-6">
      <div className="mx-auto flex items-center justify-between">
        {/* Business information on the left */}
        <div className="flex items-center" />

        {/* User profile section with business switcher popover */}
        <BusinessSwitcher />
      </div>
    </div>
  );
};

export default BusinessHeader;
